import { timestamp as time } from '@fingermarkglobal/utilities';
import { assign } from 'xstate';
import { TransactionResult } from '../../../utils';

const createPayload = assign((context, { amount, config }) => {
  return { amount, config };
});

const handlePayment = assign((context, event) => ({ ...context, ...event.data }));

const respondAfter = (resolve, reject, data, timeout) => {
  logger.info('transactions - payment - mock response', data);

  setTimeout(() => {
    try {
      if (data.result === TransactionResult.SUCCESS) {
        resolve(data);
      } else {
        reject(data.errorCondition);
      }
    } catch (err) {
      reject(err);
      logger.error('payment - respondAfter - error:', err);
    }
  }, timeout);
};

const executePayment = context =>
  new Promise((resolve, reject) => {
    const { amount } = context;
    const provider = context?.config?.provider;
    const paymentType = provider === 'momopay' ? 'MOMOPAY' : 'CARD';

    const baseResponse = {
      transInfo: {
        approvalCode: 'APPROVALCODEMOCK12345',
      },
    };

    const response =
      provider === 'ksaMada'
        ? {
            ...baseResponse,
            transactionResponse: { value: 'APPROVED' },
            emvTagsIssuer: { value: '0|1|2|3|4|0|1|2|3|4' },
            cardAcceptorName2: { value: 'Bank of Example' },
            cardAcceptorIdCode: { value: '123456789' },
            cardAcceptorTerminalId: { value: 'TERMINAL123' },
            cardAcceptorBusinessCode: { value: '5999' },
            transactionStan: { value: '987654' },
            merchantInfo: { value: 'Example Merchant|AdditionalInfo|MoreInfo' },
            retrievalReferenceNumber: { value: '112233445566' },
          }
        : baseResponse;

    const result = TransactionResult.SUCCESS;
    const transactionId = 'MOCK12345';
    const timestamp = time();
    const errorCondition = null;
    const timeout = 5 * 1000;
    const authCode = '12345';

    const info = {
      paymentType,
      transactionId,
      authCode,
      amount,
      response,
    };

    if (paymentType === 'CARD') {
      info.cardNumber = '**** **** **** 3920';
      info.cardType = 'VISA';
    }

    const defaultData = {
      result,
      errorCondition,
      response,
      transactionID: transactionId,
      timestamp,
      info,
    };

    switch (true) {
      case amount >= 70 && amount <= 79.99: {
        const data = {
          ...defaultData,
          result: TransactionResult.NOT_ALLOWED,
          errorCondition: 'payment failure',
        };

        return respondAfter(resolve, reject, data, timeout);
      }
      case amount >= 80 && amount <= 89.99: {
        const data = {
          ...defaultData,
          result: TransactionResult.NOT_ALLOWED,
          errorCondition: 'payment failure (after 15s)',
          response: {
            data: { message: 'something went wrong with payment' },
          },
        };

        return respondAfter(resolve, reject, data, 15 * 1000);
      }
      case amount >= 90 && amount <= 99.99: {
        const data = {
          ...defaultData,
          result: TransactionResult.NOT_ALLOWED,
          errorCondition: 'payment failure (timeout)',
        };

        return respondAfter(resolve, reject, data, 100 * 1000);
      }
      default:
        return respondAfter(resolve, reject, defaultData, timeout);
    }
  });

export { createPayload, handlePayment, executePayment };
